<template>
  <div dir="rtl" class="min-h-screen p-4 md:p-6 bg-slate-950 text-slate-100">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
      <div class="glass rounded-lg p-4 md:p-5 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3 col-span-2">
        <div class="flex items-center gap-3 min-w-0">
          <div class="w-10 h-10 rounded-xl bg-emerald-500/10 border border-emerald-400/20 flex items-center justify-center"  style="max-width: 40px; margin-left: 10px">
            <svg class="w-5 h-5 text-fuchsia-200" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 3v18h18M7 16V9m4 7V5m4 11v-7m4 7V8"/>
            </svg>
          </div>
          <div class="min-w-0">
            <h1 class="text-lg md:text-xl font-extrabold truncate">
            <span class="bg-gradient-to-l from-fuchsia-300 via-sky-300 to-emerald-200 bg-clip-text text-transparent">
              گزارش موجودی بر اساس برند
            </span>
            </h1>
            <div class="text-xs text-slate-400 mt-1 flex items-center gap-2 flex-wrap">
              <span v-if="lastUpdatedAt">آخرین بروزرسانی: {{ formatTime(lastUpdatedAt) }}</span>
              <span v-else>آخرین بروزرسانی: —</span>
              <span class="w-1 h-1 rounded-full bg-slate-600 hidden md:inline-block"></span>
              <span class="inline-flex items-center gap-1">
              <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
              آنلاین
            </span>
            </div>
          </div>
        </div>

        <div class="flex items-center gap-2 md:gap-3 justify-end flex-wrap">
          <button
              @click="refreshData"
              :disabled="loading"
              class="btn"
              title="Refresh"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            <span class="text-sm">بروزرسانی</span>
          </button>

          <button @click="exportToCSV" class="btn btn--green" title="CSV" disabled>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
            </svg>
            <span class="text-sm">خروجی CSV</span>
          </button>
        </div>
      </div>

      <div class="glass rounded-lg p-4 md:p-5 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div class="flex items-center gap-3 min-w-0 ">
          <div class="w-10 h-10 rounded-xl bg-sky-500/10 border border-sky-400/20 flex items-center justify-center"  style="max-width: 40px; margin-left: 10px">
            <svg class="w-5 h-5 text-sky-300" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 7h10M7 12h10M7 17h10"/>
            </svg>
          </div>
          <div>
            <div class="text-xs text-slate-400 mb-1">تعداد برند ها</div>
            <div class="text-2xl font-black">{{ filteredInventory.length }}</div>
          </div>
        </div>
      </div>

      <div class="glass rounded-lg p-4 md:p-5 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <div class="w-10 h-10 rounded-xl bg-emerald-500/10 border border-emerald-400/20 flex items-center justify-center"  style="max-width: 40px; margin-left: 10px">
            <svg class="w-5 h-5 text-emerald-300" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 7l-8 10L4 11"/>
            </svg>
          </div>

          <div>
            <div class="text-xs text-slate-400 mb-1">مجموع موجودی تعدادی</div>
            <div class="text-2xl font-black">{{ formatInt(totalInventory) }}</div>
          </div>
        </div>
      </div>
    </div>


    <!-- Controls -->
    <div class="glass rounded-2xl p-4 mb-4">
      <div class="flex flex-col md:flex-row md:items-center gap-3 md:gap-4">
        <div class="flex-1 relative">
          <span class="absolute inset-y-0 right-3 flex items-center text-slate-400 pointer-events-none">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z"/>
            </svg>
          </span>
          <input
              v-model="searchQuery"
              type="text"
              class="w-full pr-10 pl-3 py-2 rounded-xl bg-white/5 border border-white/10 focus:outline-none focus:ring-2 focus:ring-sky-400/30"
              placeholder="جستجو (نام برند)..."
          />
        </div>

      </div>
    </div>

    <!-- Main -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <!-- Table -->
      <div class="lg:col-span-2 glass rounded-2xl overflow-hidden border border-white/10">
        <div class="px-4 py-3 flex items-center justify-between border-b border-white/10">
          <div class="text-sm font-bold text-slate-200">لیست</div>
          <div class="text-xs text-slate-400" v-if="loading">در حال دریافت...</div>
          <div class="text-xs text-slate-400" v-else>نمایش {{ filteredInventory.length }} مورد</div>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full">
            <thead class="bg-white/5">
            <tr class="text-xs text-slate-300">
              <th class="p-3 text-right whitespace-nowrap cursor-pointer" @click="setSort('group')">نام برند</th>
              <th class="p-3 text-right whitespace-nowrap cursor-pointer" @click="setSort('value')">ارزش موجودی</th>
              <th class="p-3 text-right whitespace-nowrap cursor-pointer" @click="setSort('total_inventory')">موجودی</th>
            </tr>
            </thead>

            <tbody class="divide-y divide-white/5">
            <tr v-if="!loading && filteredInventory.length === 0">
              <td colspan="5" class="p-6 text-center text-slate-400">یافت نشد</td>
            </tr>

            <!-- Skeleton -->
            <tr v-if="loading" v-for="i in 6" :key="'sk_' + i">
              <td class="p-3"><div class="h-4 w-40 bg-white/5 rounded"></div></td>
              <td class="p-3"><div class="h-4 w-44 bg-white/5 rounded"></div></td>
              <td class="p-3"><div class="h-4 w-24 bg-white/5 rounded"></div></td>
              <td class="p-3"><div class="h-4 w-48 bg-white/5 rounded"></div></td>
              <td class="p-3"><div class="h-4 w-16 bg-white/5 rounded"></div></td>
            </tr>

            <tr
                v-for="(item, idx) in filteredInventory"
                :key="item.group + '_' + idx"
                class="hover:bg-white/5 transition"
            >
              <!-- Name -->
              <td class="p-3">
                <div class="flex items-center gap-2 min-w-0">
                  <span class="w-3 h-3 rounded-full shrink-0" :style="{backgroundColor: colorHex(item.group)}"></span>
                  <div class="font-bold text-slate-100 truncate max-w-[260px]">{{ item.group }}</div>
                </div>
              </td>

              <td class="p-3">
                <div class="flex flex-col">
                  <div class="text-lg font-extrabold text-slate-100">
                    {{ item.value | toMoney(0) }}
                  </div>
                  <div class="text-[11px] text-slate-400 mt-0.5 flex flex-wrap gap-2">
                      <span class="badge">
                        پایه: {{ item.total_base | toMoney(0) }}
                      </span>
                    <span class="badge">
                        کرایه: {{ item.total_shipping_cost | toMoney(0) }}
                      </span>
                  </div>
                </div>
              </td>

              <!-- Inventory Count -->
              <td class="p-3">
                <div class="flex flex-col">
                  <div class="text-lg font-extrabold text-slate-100">
                    {{ formatInt(item.total_inventory) }}
                    <span class="text-xs text-slate-400 mr-2">عدد</span>
                  </div>
                  <div class="text-[11px] text-slate-500">موجودی تعدادی</div>
                </div>
              </td>

            </tr>
            </tbody>

          </table>
        </div>
      </div>

      <!-- Right Panel -->
      <div class="glass rounded-2xl p-4 border border-white/10">
        <div class="flex items-center justify-between mb-3">
          <div class="text-sm font-bold text-slate-200">Top 5</div>
          <div class="text-xs text-slate-400">براساس برند موجودی</div>
        </div>

        <div class="space-y-3">
          <div
              v-for="it in top5"
              :key="it.group + '_top'"
              class="rounded-2xl p-3 bg-white/5 border border-white/10"
          >
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center gap-2 min-w-0">
                <span class="w-3 h-3 rounded-full shrink-0" :style="{backgroundColor: colorHex(it.group)}"></span>
                <span class="font-bold text-slate-100 truncate">{{ it.group }}</span>
              </div>
              <span class="text-xs text-slate-300">{{ pct(it.value, totalValue) }}%</span>
            </div>

            <div class="mt-2 grid grid-cols-2 gap-2 text-xs text-slate-400">
              <div class="flex items-center justify-between bg-white/5 border border-white/10 rounded-xl px-2 py-1">
                <span>ارزش</span>
                <span class="text-slate-200 font-bold">{{ formatMoney0(it.value) }}</span>
              </div>
              <div class="flex items-center justify-between bg-white/5 border border-white/10 rounded-xl px-2 py-1">
                <span>تعداد</span>
                <span class="text-slate-200 font-bold">{{ formatInt(it.total_inventory) }}</span>
              </div>
            </div>

            <div class="mt-2 h-2 rounded-full bg-white/5 border border-white/10 overflow-hidden">
              <div class="h-full rounded-full" :style="shareBarStyle(it)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="glass rounded-2xl p-4 mb-4 mt-4">
      <div class="flex items-center justify-between mb-2">
        <div class="text-sm font-bold text-slate-200">توزیع ارزش موجودی</div>
      </div>

      <div class="h-3 rounded-full bg-white/5 border border-white/10 overflow-hidden flex">
        <template v-if="totalValue > 0">
          <div
              v-for="seg in distributionSegments"
              :key="seg.key"
              class="h-full"
              :style="{ width: seg.width + '%', backgroundColor: seg.color }"
              :title="seg.title"
          ></div>
        </template>
        <div v-else class="h-full w-full bg-white/5"></div>
      </div>

      <div class="mt-3 flex flex-wrap gap-2">
        <div
            v-for="seg in distributionSegments.slice(0, 8)"
            :key="seg.key + '_legend'"
            class="chip"
        >
          <span class="w-2.5 h-2.5 rounded-full" :style="{backgroundColor: seg.color}"></span>
          <span class="text-xs text-slate-200 max-w-[140px] truncate">{{ seg.name }}</span>
          <span class="text-[11px] text-slate-400">{{ seg.width | toMoney}}%</span>
        </div>

        <div v-if="distributionSegments.length > 8" class="text-xs text-slate-400 px-2 py-1">
          +{{ distributionSegments.length - 8 }} مورد دیگر
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "InventoryReportByBrand",
  data() {
    return {
      inventory: [],
      loading: false,

      searchQuery: "",
      hideZero: false,

      sortKey: "value",
      sortDir: "desc",

      lastUpdatedAt: null,
    };
  },
  computed: {
    normalized() {
      const src = Array.isArray(this.inventory) ? this.inventory : [];
      return src.map(x => {
        const group = (x.group ?? "").toString();
        const total_inventory = Number(x.total_inventory || 0);

        const total_base = Number(x.total_base || 0);
        const total_shipping_cost = Number(x.total_shipping_cost || 0);

        const value = total_base + total_shipping_cost;

        return {
          group,
          total_inventory,
          total_base,
          total_shipping_cost,
          value,
        };
      });
    },
    filteredInventory() {
      let data = [...this.normalized];

      if (this.hideZero) data = data.filter(x => x.total_inventory > 0);

      if (this.searchQuery && this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase();
        data = data.filter(x => (x.group || "").toLowerCase().includes(q));
      }

      const key = this.sortKey;
      const dir = this.sortDir === "desc" ? -1 : 1;

      data.sort((a, b) => {
        const av = a[key];
        const bv = b[key];

        if (typeof av === "string" || typeof bv === "string") {
          return av.localeCompare(bv, "fa") * dir;
        }
        return (av - bv) * dir;
      });

      return data;
    },
    totalInventory() {
      return this.filteredInventory.reduce((sum, it) => sum + (Number(it.total_inventory) || 0), 0);
    },
    totalValue() {
      return this.filteredInventory.reduce((sum, it) => sum + (Number(it.value) || 0), 0);
    },
    top5() {
      return [...this.filteredInventory].sort((a, b) => b.value - a.value).slice(0, 5);
    },
    distributionSegments() {
      const total = this.totalValue || 0;
      if (!total) return [];

      return [...this.filteredInventory]
          .sort((a, b) => b.value - a.value)
          .map(it => {
            const w = (it.value / total) * 100;
            return {
              key: it.group,
              name: it.group,
              width: Math.max(0, w),
              color: this.colorHex(it.group),
              title: `${it.group} — ارزش: ${this.formatMoney0(it.value)} — ${w.toFixed(1)}%`,
            };
          })
          .filter(s => s.width > 0);
    },
  },
  created() {
    this.fetchInventories();
  },
  methods: {
    fetchInventories() {
      this.loading = true;
      this.request({
        url: this.endpoint("product/inventory/brand"),
        method: "get",
        success: (data) => {
          this.inventory = Array.isArray(data) ? data : [];
          this.lastUpdatedAt = new Date();
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
    },
    refreshData() {
      this.resetFilters(false);
      this.fetchInventories();
    },
    resetFilters(resetData = false) {
      this.searchQuery = "";
      this.hideZero = true;
      this.sortKey = "value";
      this.sortDir = "desc";
      if (resetData) this.inventory = [];
    },
    setSort(key) {
      if (this.sortKey === key) this.toggleSortDir();
      else {
        this.sortKey = key;
        this.sortDir = (key === "group") ? "asc" : "desc";
      }
    },
    toggleSortDir() {
      this.sortDir = this.sortDir === "desc" ? "asc" : "desc";
    },

    // ---------- UI Helpers ----------
    formatInt(n) {
      return Math.round(Number(n || 0)).toLocaleString("fa-IR");
    },
    // money بدون اعشار
    formatMoney0(n) {
      const num = Math.round(Number(n || 0));
      return num.toLocaleString("fa-IR");
    },
    formatExchange(n) {
      return Number(n || 0).toLocaleString("fa-IR");
    },
    formatTime(d) {
      try { return new Date(d).toLocaleTimeString("fa-IR"); } catch (e) { return "—"; }
    },
    pct(part, total) {
      const t = Number(total || 0);
      if (!t) return "0.0";
      return ((Number(part || 0) / t) * 100).toFixed(1);
    },
    shareBarStyle(item) {
      const total = this.totalValue || 0;
      const w = total ? (item.value / total) * 100 : 0;
      const c = this.colorHex(item.group);
      return {
        width: `${Math.min(100, Math.max(0, w))}%`,
        backgroundColor: c,
        boxShadow: `0 0 18px ${c}55`,
      };
    },

    // رنگ ثابت بر اساس نام گروه
    colorHex(name) {
      const palette = ["#60a5fa","#34d399","#f472b6","#a78bfa","#fb7185","#22d3ee","#fbbf24","#c084fc","#4ade80","#93c5fd"];
      const str = (name || "").toString();
      let seed = 0;
      for (let i = 0; i < str.length; i++) seed = (seed + str.charCodeAt(i) * (i + 1)) % 100000;
      return palette[seed % palette.length];
    },

    exportToCSV() {
      const headers = ["group", "value", "total_inventory", "total_base", "total_shipping_cost", "exchange"];
      const rows = this.filteredInventory.map(it => [
        `"${(it.group || "").replace(/"/g, '""')}"`,
        it.value,
        it.total_inventory,
        it.total_base,
        it.total_shipping_cost,
        it.exchange,
      ]);
      const csv = [headers.join(","), ...rows.map(r => r.join(","))].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `inventory_value_by_currency_${Date.now()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.glass{
  background: rgba(2, 6, 23, 0.55);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border: 1px solid rgba(255, 255, 255, 0.10);
  box-shadow:
      0 20px 60px rgba(0, 0, 0, 0.55),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
  position: relative;
  isolation: isolate;
}
.glass::before{
  content:"";
  position:absolute;
  inset:0;
  pointer-events:none;
  background:
      radial-gradient(circle at 18% 12%, rgba(255,255,255,0.08), transparent 45%),
      radial-gradient(circle at 90% 20%, rgba(99,102,241,0.10), transparent 40%),
      linear-gradient(to bottom, rgba(255,255,255,0.06), transparent 35%);
}
.glass > *{ position:relative; z-index:1; }

/* کنترل‌ها */
.ctl{
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: .5rem .75rem;
  border-radius: 0.75rem;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.10);
  outline: none;
}

/* ✅ دکمه‌ها max-width دارن که کش نیان */
.btn{
  max-width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: inline-flex;
  align-items: center;
  gap: .5rem;

  padding: .5rem .75rem;
  border-radius: 0.75rem;

  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.10);

  transition: .2s ease;
}
.btn:hover{ background: rgba(255,255,255,0.10); }
.btn:disabled{ opacity: .5; cursor: not-allowed; }

.btn--green{
  background: linear-gradient(270deg, rgba(16,185,129,.75), rgba(34,197,94,.45));
  border-color: rgba(16,185,129,.25);
}
.btn--green:hover{ opacity: .92; }

.btn--amber{
  background: rgba(245,158,11,0.14);
  border-color: rgba(245,158,11,0.25);
  color: rgb(253,230,138);
}

/* ✅ badge ها max-width دارن */
.badge{
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: inline-flex;
  align-items: center;
  gap: .35rem;

  padding: .15rem .5rem;
  border-radius: 999px;

  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.10);
}

/* chip ها */
.chip{
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: inline-flex;
  align-items: center;
  gap: .5rem;

  padding: .25rem .6rem;
  border-radius: 0.85rem;

  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.10);
}
</style>
